module.exports = __webpack_public_path__ + "static/media/newlogo.7350bd34.svg";